<template>
    <div class="about">
        <div class="top-actions">
            <el-button type="default" size="small" icon="el-icon-refresh" @click="handleRefresh"></el-button>
            <el-button type="default" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
            <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDeleteSelected">删除</el-button>

            <div class="search-container">
                <el-input placeholder="搜索" v-model="searchQuery" suffix-icon="el-icon-search"
                    @input="handleSearch"></el-input>
                <el-button type="default" icon="el-icon-search"
                    @click="showSearchFields = !showSearchFields"></el-button>
            </div>
        </div>
        <div v-if="showSearchFields" class="advanced-search-fields">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form :model="searchForm" label-width="100px">
                        <el-form-item label="任务ID">
                            <el-input v-model="searchForm.taskId" placeholder="请输入任务ID"></el-input>
                        </el-form-item>
                        <el-form-item label="任务名">
                            <el-input v-model="searchForm.taskName" placeholder="请输入任务名"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="12">
                    <el-form :model="searchForm" label-width="100px">
                        <el-form-item label="采集源">
                            <el-input v-model="searchForm.collectionSource" placeholder="请输入采集源"></el-input>
                        </el-form-item>
                        <el-form-item label="创建时间">
                            <el-date-picker v-model="searchForm.creationTime" type="date" placeholder="选择日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-button type="primary" @click="handleAdvancedSearch">提交</el-button>
            <el-button type="default" @click="showSearchFields = false">取消</el-button>
        </div>

        <el-table ref="filterTable" :data="paginatedTableData"
            :header-cell-style="{ color: '#606266', background: '#f5f7fa' }" style="width: 100%" stripe border
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="user_id" label="任务ID" sortable width="180"></el-table-column>
            <el-table-column prop="nickname" label="昵称"></el-table-column>
            <el-table-column prop="content" label="评论内容"></el-table-column>
            <el-table-column prop="comment_id" label="评论ID"></el-table-column>
            <el-table-column prop="create_time" label="采集时间">
                <template slot-scope="scope">
                    {{ formatDate(scope.row.create_time) }}
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    <el-button size="mini" type="primary" @click="handleCopyHomepage(scope.row)">复制主页</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="currentPage"
                :page-sizes="[50, 100, 200]" :page-size="pgSize" :total="filteredTableData.length"
                @size-change="handleSizeChange" @current-change="handlePageChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { kuaishou_video_comment, kuaishou_video_comment2, kuaishou_video_comment3, delete_kuaishou_video_comment } from '@/api/ks';
import moment from 'moment';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
    data() {
        return {
            currentPage: 1,
            pgSize: 50,  // 每页显示50条
            idx: -1,
            editVisible: false,
            form: {},
            searchQuery: '',
            showSearchFields: false,
            searchForm: {
                taskId: '',
                taskName: '',
                collectionSource: '',
                creationTime: ''
            },
            selectedRows: [],
            tableData: []
        }
    },
    computed: {
        // 过滤后的数据（包含搜索和高级搜索）
        filteredTableData() {
            let data = [...this.tableData];

            // 简单搜索
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                data = data.filter(item =>
                    Object.values(item).some(value =>
                        String(value).toLowerCase().includes(query)
                    )
                );
            }

            // 高级搜索
            if (this.searchForm.taskId) {
                data = data.filter(item =>
                    item.user_id.toString().includes(this.searchForm.taskId)
                );
            }

            if (this.searchForm.taskName) {
                data = data.filter(item =>
                    item.nickname.toLowerCase().includes(this.searchForm.taskName.toLowerCase())
                );
            }

            if (this.searchForm.collectionSource) {
                data = data.filter(item =>
                    item.note_url.toLowerCase().includes(this.searchForm.collectionSource.toLowerCase())
                );
            }

            if (this.searchForm.creationTime) {
                const date = this.searchForm.creationTime;
                data = data.filter(item =>
                    moment(item.create_time).format('YYYY-MM-DD') === date
                );
            }

            return data;
        },
        // 分页后的数据
        paginatedTableData() {
            const start = (this.currentPage - 1) * this.pgSize;
            const end = start + this.pgSize;
            return this.filteredTableData.slice(start, end);
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        // 根据用户角色获取对应的API
        getApiByRole() {
            const userRole = localStorage.getItem('userRole') || 'admin';

            const apiMap = {
                'admin': kuaishou_video_comment,
                'manager': kuaishou_video_comment2,
                'zhuzhu': kuaishou_video_comment3,
                'huolong':kuaishou_video_comment3,
                'buzhi': kuaishou_video_comment3,
                'ruiqi': kuaishou_video_comment3,
                'daolai': kuaishou_video_comment3,
                'yangguang': kuaishou_video_comment3,
                'demo': kuaishou_video_comment3,
                'jinlianan': kuaishou_video_comment3,
                'jinlianan2': kuaishou_video_comment3,
                'dianguang1':kuaishou_video_comment3,
                'dianguang2': kuaishou_video_comment3,
                'dianguang3': kuaishou_video_comment3,
                'demo': kuaishou_video_comment8,
                
            };

            return apiMap[userRole] || kuaishou_video_comment;
        },
        fetchData() {
            const api = this.getApiByRole();
            api().then(response => {
                this.tableData = response.data.map(item => ({
                    user_id: item.user_id,
                    nickname: item.nickname,
                    note_url: item.note_url,
                    content: item.content,
                    comment_id: item.comment_id,
                    create_time: item.create_time,
                    sec_uid: item.sec_uid,
                }));
            }).catch(error => {
                console.error('获取数据时出错！', error);
                this.$message.error('获取数据失败');
            });
        },
        handleExport() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请先选择要导出的行！');
                return;
            }

            const dataToExport = this.selectedRows.map(item => {
                const user_id = item.user_id;
                const homepageUrl = `https://www.kuaishou.com/profile/${user_id}`;
                return {
                    "任务ID": item.user_id,
                    "昵称": item.nickname,
                    "评论内容": item.content,
                    "评论ID": item.comment_id,
                    "采集时间": this.formatDate(item.create_time),
                    "主页链接": homepageUrl
                };
            });

            const worksheet = XLSX.utils.json_to_sheet(dataToExport);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([wbout], { type: "application/octet-stream" });
            saveAs(blob, '导出数据.xlsx');
        },
        handleRefresh() {
            this.fetchData();
        },
        // handleCopyHomepage(row) {
        //     const user_id = row.user_id;
        //     const homepageUrl = `https://www.kuaishou.com/profile/${user_id}`;
        //     if (homepageUrl) {
        //         navigator.clipboard.writeText(homepageUrl).then(() => {
        //             this.$message.success('主页链接已复制到剪贴板');
        //         }).catch(err => {
        //             this.$message.error('无法复制主页链接');
        //         });
        //     } else {
        //         this.$message.warning('没有找到主页链接');
        //     }
        // },

        handleCopyHomepage(row) {
            const user_id = row.user_id;
            const homepageUrl = `https://www.kuaishou.com/profile/${user_id}`;

            if (!homepageUrl) {
                this.$message.warning('没有找到主页链接');
                return;
            }

            // 创建一个 textarea 并复制内容
            const textArea = document.createElement("textarea");
            textArea.value = homepageUrl;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                this.$message.success('主页链接已复制到剪贴板');
            } catch (err) {
                this.$message.error('复制失败，请手动复制');
            } finally {
                document.body.removeChild(textArea);
            }
        },


        handleAdvancedSearch() {
            this.currentPage = 1; // 重置到第一页
            this.showSearchFields = false;
        },
        handleDeleteSelected() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请先选择要删除的行！');
                return;
            }

            const userIds = this.selectedRows.map(row => row.user_id);
            this.$confirm('确定要删除选中的记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                Promise.all(userIds.map(id => delete_kuaishou_video_comment(id)))
                    .then(() => {
                        this.$message.success('删除成功');
                        this.fetchData(); // 刷新数据
                        this.selectedRows = []; // 清空选中项
                    })
                    .catch(error => {
                        this.$message.error('部分删除失败');
                        console.error('批量删除时出错！', error);
                    });
            }).catch(() => { });
        },
        handleDelete(index, row) {
            this.$confirm('确定要删除这条记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delete_kuaishou_video_comment(row.user_id).then(() => {
                    this.$message.success('删除成功');
                    this.fetchData(); // 刷新数据
                }).catch(error => {
                    this.$message.error('删除失败');
                    console.error('删除时出错！', error);
                });
            }).catch(() => { });
        },
        handlePageChange(val) {
            this.currentPage = val;
        },
        handleSizeChange(val) {
            this.pgSize = val;
            this.currentPage = 1; // 重置到第一页
        },
        handleSelectionChange(selection) {
            this.selectedRows = selection;
        },
        formatDate(dateString) {
            if (!dateString) return '';
            return moment(dateString).format('YYYY-MM-DD HH:mm:ss');
        },
        resetDateFilter() {
            this.$refs.filterTable.clearFilter('date');
        },
        clearFilter() {
            this.$refs.filterTable.clearFilter();
        },
        filterTag(value, row) {
            return row.tag === value;
        },
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        }
    }
}
</script>

<style lang="stylus">
.top-actions
    display flex
    align-items center
    justify-content space-between
    margin-bottom 10px

.search-container
    margin-left: auto

.button-container
    margin-right: auto

.advanced-search-fields {
    margin-bottom: 10px;
}


</style>